// Stylesheet load order is declared here, and only here. Every override in
// src/styles depends on Bootstrap being first, so it must not be imported from
// a component module — the component import graph decides order, and it used to
// put App.css (via Navbar) ahead of Bootstrap by accident.
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/tokens.css';
import './styles/bootstrap-bridge.css';
import './styles/base.css';
import './styles/motion.css';
import './styles/utilities.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
